import { FC } from "react";
import { QbdFileMigrationUploadSource } from "@common/schemas/accounting-integration.schema";
import { Task } from "@common/types/task";
import { useSetQbdFileMigrationUploadSourceMutation } from "@api/accountingIntegration.api";
import { Button } from "@design-system/Button/Button";
import { useToaster } from "@design-system/ToastMessages/useToaster";
import { useScope } from "@state/scopeContext.lib";

interface Props {
    selectedTask: Task;
    source: QbdFileMigrationUploadSource;
    disabled?: boolean;
}

export const QbdUploadPathFallbackButton: FC<Props> = ({
    selectedTask,
    source,
    disabled = false,
}) => {
    const { workspaceId } = useScope();
    const entityId = selectedTask.entityIds?.[0];
    const { error: toastError } = useToaster();
    const nextSource = source === "qbdt_json" ? "qbdt" : "qbdt_json";
    const mutation = useSetQbdFileMigrationUploadSourceMutation({
        workspaceId: workspaceId ?? "",
        entityId: entityId ?? 0,
    });

    if (!workspaceId || !entityId) {
        return null;
    }

    return (
        <Button
            variant="link"
            size="sm"
            disabled={disabled || mutation.isPending}
            onClick={() => {
                mutation.mutate(nextSource, {
                    onError: () =>
                        toastError(
                            "Couldn't switch the QuickBooks Desktop upload path. Please try again.",
                        ),
                });
            }}
        >
            {source === "qbdt_json"
                ? "Use GL export instead"
                : "Use JSON exporter instead"}
        </Button>
    );
};
